import React, { useState } from "react";

const CopyToClipboardButton = ({ text }) => {
    const [isCopied, setIsCopied] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    const handleCopyClick = async () => {
        if (isAnimating) return;

        try {
            await navigator.clipboard.writeText(text);
            setIsCopied(true);
            setIsAnimating(true);
            
            // Reset states after animation
            setTimeout(() => {
                setIsCopied(false);
                setIsAnimating(false);
            }, 1500);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <button 
            onClick={handleCopyClick} 
            className='clone'
            aria-label={isCopied ? 'Copied!' : 'Copy to clipboard'}
            disabled={isAnimating}
        >
            {isCopied ? 
                <i className="fa-solid fa-check" /> : 
                <i className="fa-regular fa-copy" />
            }
        </button>
    );
};

export default CopyToClipboardButton;